import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://testeaofertas.com/cart/48211071664180:1';
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  children,
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-5 py-3 text-sm';
  return <a href={CHECKOUT_URL} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-ember-500 font-display font-extrabold uppercase tracking-wide text-white shadow-lg shadow-ember-600/25 transition-[background-color,transform] duration-150 ease-out hover:bg-ember-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember-500 active:translate-y-px ${sizing} ${className}`} data-id="element-28" data-mp="qjsbxkunxhad">
      <span data-id="element-29" data-mp="159gcukyxmdxk">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-30" data-mp="15a9b0xjtrv43" />
    </a>;
}